import {bindActionCreators, compose} from 'redux';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {actions} from '../../../redux/actions';

const mapStateToProps = (state: any) => {
  return {
    mails: state.mails,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: {
      mails: bindActionCreators(actions.mails, dispatch),
    },
  };
};

const enhance: any = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'mailsMain',
  })
);

export {enhance};
